module.exports = __webpack_public_path__ + "bb5b68d7038e9080d570e88cadf563d8.png";